import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-smiley',
  templateUrl: './smiley.component.html',
  styleUrls: ['./smiley.component.scss']
})
export class SmileyComponent implements OnInit {

  caseID:string
  sadImgSrc: string = "assets/smiley/sad-default.svg"
  neutralImgSrc: string = "assets/smiley/neutral-default.svg"
  smileImgSrc: string = "assets/smiley/smile-default.svg"
  constructor(private router: Router) { }

  ngOnInit() {
    const SStorage = JSON.parse(sessionStorage.ServiceHeader);
    this.caseID = SStorage.CaseID;
  }
}
